import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  close() {
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler('onComplete');
    } else {
      throw new Error('Flutter InAppWebView is not available');
    }
  }
}
